import {
  Button,
  Card,
  Checkbox,
  Col,
  FloatButton,
  Row,
  Typography,
} from "antd";
import { useEffect, useState } from "react";
import config from "../config";
import moment from "moment";
import { useCountry } from "../provider/courtryProvider";
import { CheckCircleOutlined } from "@ant-design/icons";
import { TfiShoppingCartFull } from "react-icons/tfi";
import Cart from "./pricingCart";
import useLocalStorage from "../hooks/useLocalstorage";
import Loader from "./loader";
import { useLoader } from "../provider/PricingLoaderProvider";

const PackageCard = ({
  item,
  handleCartClick = () => {},
  isExistInCart = () => {},
}) => {
  const country = useCountry();
  const [checkedValue, setCheckedValue] = useState([]);
  const isExist = isExistInCart(item);

  useEffect(() => {
    setCheckedValue(item.defaultChecked);
  }, [item.defaultChecked]);
  return (
    <Card
      style={{
        height: "100%",
      }}
      bodyStyle={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <Typography.Title level={4}>{item.name}</Typography.Title>
      {/* {item.isDetails && (
        <span
          role="button"
          onClick={() => {
            setClickInfo((prev) => !prev);
            setpackageId(item.id);
          }}
        >
          <GoInfo
            size={20}
            style={{
              position: "absolute",
              right: 20,
              top: 20,
              cursor: "pointer",
            }}
          />
        </span>
      )} */}
      <div
        style={{
          flexGrow: 1,
        }}
      >
        {item.description && (
          <Typography.Text type="primary">{item.description}</Typography.Text>
        )}
        <Typography.Text
          style={{
            display: "block",
            color: "#ef4667",
            fontSize: 26,
            fontWeight: "600",
            userSelect: "none",
          }}
        >
          {country.CurrencySymbol}
          {(moment(item.offerValidity, "DD MMM YYYY").isSameOrBefore(
            moment()
          ) &&
            item.price) ||
            item.discountPrice}{" "}
          {!moment(item.offerValidity, "DD MMM YYYY").isSameOrBefore(
            moment()
          ) && (
            <Typography.Text
              style={{
                textDecorationLine: "line-through",
                fontSize: 16,
                color: "#828282",
              }}
            >
              {country.CurrencySymbol} {item.price}{" "}
            </Typography.Text>
          )}
          <Typography.Text style={{ color: "#3F3F3F", fontSize: 16 }}>
            {" "}
            / {item.packageValidity}
          </Typography.Text>
          <Typography.Text style={{ fontSize: 14, color: "#A4A4A4" }}>
            {" "}
            {item.taxType === "inclusive"
              ? `(Inclusive of GST)`
              : `(Exclusive of GST)`}
          </Typography.Text>
        </Typography.Text>
        <>
          <div
            style={{
              borderBottomColor: "#D4D4D4",
              borderBottomWidth: 1,
            }}
          />
          {item.isDetails && (
            <div>
              {item.details.map((data, index) => {
                return (
                  <div
                    key={index}
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      marginBottom: 10,
                      display: "flex",
                      gap: 8,
                    }}
                  >
                    <CheckCircleOutlined
                      style={{ color: "#4BB74F", fontSize: 18 }}
                    />
                    <span> {"  " + data}</span>
                  </div>
                );
              })}
            </div>
          )}
        </>

        {item.isButtonType && (
          <div>
            {item.buttonType === "checkBox" &&
              item.buttonItems.map((button) => {
                return (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      flexDirection: "row",
                    }}
                  >
                    <Checkbox
                      checked={checkedValue?.includes(button.value)}
                      onChange={(e) => {
                        const v = e.target.checked;
                        if (v) {
                          if (checkedValue.length === item.checkboxChecked) {
                            setCheckedValue((prev) => {
                              return [...prev, button.value].slice(
                                1,
                                item.checkboxChecked + 1
                              );
                            });
                          }
                        }
                      }}
                    >
                      {button.label}
                    </Checkbox>
                  </div>
                );
              })}
          </div>
        )}
      </div>
      <Button
        type="primary"
        style={{
          width: "100%",
          marginTop: 16,
        }}
        onClick={() => handleCartClick(item, isExist)}
      >
        {isExist ? "Remove from Cart" : "Add to Cart"}
      </Button>
    </Card>
  );
};
const PlanAndPricing = () => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openCart, setOpenCart] = useState(false);
  const [cartList, setCartList] = useLocalStorage("cart", []);
  const [loader] = useLoader();
  const fetchPackage = async () => {
    try {
      let data = await fetch(config.package, {
        headers: {
          "Cache-Control": "no-cache",
        },
      });
      let res = await data.json();
      return res;
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const handleCartClick = (v, exist) => {
    setCartList((prev) => {
      if (exist) {
        return cartList.filter((i) => i.id !== v.id);
      }
      return [...prev, v];
    });
  };

  console.log("cartList", cartList);

  useEffect(() => {
    (async function () {
      const plans = await fetchPackage();
      console.log("plans", plans);
      const packages = plans.plans.filter((i) => i.type === "sales");
      setPlans(packages);
    })();
  }, []);

  const isExistInCart = (item) => {
    const isExist = cartList.some((i) => i.id === item.id);
    return isExist;
  };
  return (
    <>
      {loader && (
        <div className="loading">
          <Loader size={56} />
        </div>
      )}
      <div
        style={{
          position: "relative",
        }}
      >
        {loading && (
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              zIndex: 100,
              transform: "translate(-50%, -50%)",
            }}
          >
            <Loader />
          </div>
        )}
        {!loading && (
          <div>
            <Typography.Title
              style={{
                textAlign: "center",
              }}
              level={2}
            >
              Plan and Pricing
            </Typography.Title>
            <div
              style={{
                position: "absolute",
                right: 25,
                top: 0,
                cursor: "pointer",
              }}
            >
              {/* <FloatButton
          
            
            icon={
              <Badge
                style={{
                  cursor: "pointer",
                }}
                count={cartList.length}
              >
                <TfiShoppingCartFull size={30} />
              </Badge>
            }
            type="default"
            style={{ right: 94 }}
          /> */}
              <FloatButton
                onClick={() => {
                  setOpenCart(true);
                }}
                icon={<TfiShoppingCartFull />}
                shape="circle"
                badge={{
                  count: cartList.length,
                  color: "red",
                }}
                style={{
                  right: 60,
                  transform: "scale(1.5)",
                }}
              />
            </div>
            <Row gutter={[20, 20]}>
              {plans.map((i) => {
                return (
                  <Col span={12}>
                    <PackageCard
                      item={i}
                      key={i.id}
                      handleCartClick={handleCartClick}
                      isExistInCart={isExistInCart}
                    />
                  </Col>
                );
              })}
            </Row>
            <Cart
              open={openCart}
              onClose={() => {
                setOpenCart(false);
              }}
              width={500}
              cartList={cartList}
              setCartList={setCartList}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default PlanAndPricing;
